if (!customElements.get('image-banner-video')) {
  customElements.define('image-banner-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      this.button = this.querySelector('.video-toggle');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };

      this.updateRatio = () => {
        if (this.video.videoWidth && this.video.videoHeight) {
          this.style.setProperty('--image-ratio-percent', `${this.video.videoHeight / this.video.videoWidth * 100}%`);
        }
      };
      this.video.addEventListener('loadedmetadata', () => {
        this.updateRatio();
        this.syncPlayback();
      }, options);
      for (const event of ['play', 'pause', 'ended']) {
        this.video.addEventListener(event, () => this.updateButton(), options);
      }
      if (this.button) {
        this.button.hidden = false;
        this.button.addEventListener('click', () => {
          this.userPaused = !this.video.paused;
          this.syncPlayback();
        }, options);
      }
      this.updateRatio();
      this.syncPlayback();

      const mobileSource = this.video.querySelector('source[media]');
      if (mobileSource) {
        this.breakpoint = window.matchMedia(mobileSource.media);
        // Re-select the source when resizing or rotating across the mobile breakpoint.
        this.reloadVideo = () => this.video.load();
        this.breakpoint.addEventListener('change', this.reloadVideo, options);
      }
    }

    syncPlayback() {
      // Preserve a manual pause across source changes and theme editor reconnects.
      this.video.autoplay = !this.userPaused;
      if (this.userPaused) {
        this.video.pause();
      } else {
        this.video.play().catch(() => this.updateButton());
      }
      this.updateButton();
    }

    updateButton() {
      if (!this.button) return;
      const playing = !this.video.paused && !this.video.ended;
      this.button.dataset.playing = String(playing);
      this.button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    }

    disconnectedCallback() {
      if (!this.video) return;

      this.controller?.abort();
      this.video.pause();
    }
  });
}
